import React from 'react';
import Slider from '../slider/Slider.js';
import SliderConfigs from '../slider/SliderConfigs.js';
import { config } from "../config"

class TeaserBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            investmentSize: 10,
            payBackTime: 20,
        };
        this.sliders = SliderConfigs({
            yearSliderValidation: this.yearSliderValidation,
            changeScaleToLarge: () => {
                return false;
            },
        });
        this.sliders.investmentSize.changeScale = () => {return false;};
        this.updateState = this.updateState.bind(this);
    }

    yearSliderValidation(newVal, oldVal) {
        newVal = newVal.toString().replace(",",".");
        if(isNaN(newVal)) return oldVal;
        return Math.round(newVal);
    }

    updateState(object) {
        this.setState(object);
    }

    render() {
        return (
            <div className="teaser-box">
                <h3>Vertaile rahoitusvaihtoehtoja</h3>
                <div className="teaser-box__sliders">
                    <Slider
                        state={this.state}
                        id="investmentSize"
                        updateState={this.updateState}
                        resizeFns={this.props.resizeFns}
                        sliderConfig={this.sliders}
                        key="investmentSizeLarge">
                    </Slider>
                    <Slider
                        state={this.state}
                        id="payBackTime"
                        updateState={this.updateState}
                        resizeFns={this.props.resizeFns}
                        sliderConfig={this.sliders}>
                    </Slider>
                </div>
                <a
                    href={(config.IFRAME_ORIGIN ? config.IFRAME_ORIGIN+"/vertailulaskuri/" : "/iframepoc") + "#phase1|null||" + this.state.investmentSize + "|" + this.state.payBackTime}
                    target="_parent"
                    className="action-button">VERTAILE</a>
            </div>
        );
    }
}

export default TeaserBox;
